if ( typeof QuickBuy !== 'function' ) {

	class QuickBuy extends HTMLElement {
		
		constructor(){

			super();

			// Product variant event listener for theme specific logic

			this.zIndex = 99;

			const hasProductItem = this.closest('[data-js-product-item]');

			this.productVariants = this.querySelector('product-variants');

			this.isATierSubscription = this.querySelector('.tier-quick-add');

			if ( hasProductItem ) {
				this.variantImages = this.querySelector('[data-js-quick-buy-product-images]');
				this.productImage = this.closest('[data-js-product-item]').querySelector('[data-js-product-item-image]');
				this.variantImagesSliders = this.hasAttribute('data-variant-images-slider');
				this.productSlider = this.closest('[data-js-product-item]').querySelector('css-slider');
			}

			if(this.productVariants !== null) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

			if ( this.variantImages !== null) {

				setTimeout(()=>{
					const imageObserver = new IntersectionObserver((entries, observer) => {
						if ( ! entries[0].isIntersecting ) {
							return;
						} else {
							this.variantImages.querySelectorAll(`template`).forEach(elm=>{
								if ( ! elm.dataset.init ) {
									this.initVariantImage(elm);
								}
							});
							observer.unobserve(this);
						}
					});
					imageObserver.observe(this);
				}, 5000)
			
			}

			setTimeout(()=>{

				this.querySelectorAll('.product-variant__item--radio').forEach(elm=>{

					elm.addEventListener('click', e=>{

						elm.closest('.css-slider-holder').scrollTo({
							top: 0,
							left: elm.offsetLeft - 40,
							behavior: 'smooth'
						});

						if ( elm.classList.contains('product-variant__item--color' ) ) {
							elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.querySelector('input').value;
						}

					})
				});

			}, 1000);

			// trigger cart popup 

			if ( this.querySelector('[data-js-quick-buy-form]') ) {
				this.querySelector('form').addEventListener('submit', e=>{

					e.preventDefault();


			
					const submitButton = this.querySelector('[type="submit"]');
					submitButton.classList.add('working');

					
					// Absolute addition - log to Meta: (log it now while we can easily get the data)
					if(typeof logAddToCart !== "undefined") {
						if(e.target.hasAttribute('data-variant')) {
							let variant_id = e.target.getAttribute('data-variant');
							if(e.target.closest('form').querySelector('input[name="id"]') !== null) {
								variant_id = e.target.closest('form').querySelector('input[name="id"]').value;
							}
							logAddToCart(variant_id, e.target.getAttribute('data-title'), e.target.getAttribute('data-cost'));
						}
					}

					window.handleAddToCart(
						this._serializeForm(e.currentTarget), 1,
						{
							'Content-Type': 'application/x-www-form-urlencoded',
							'X-Requested-With': 'XMLHttpRequest'
						},
						()=>{
							submitButton.classList.remove('working');
						}
					);

				});
				
			}


/*
			// update product card prices

			setTimeout(()=>{

				if ( (hasProductItem) && (this.isATierSubscription === null)) {

					const cardPrice = this.closest('[data-js-product-item]').querySelector('[data-js-product-item-price]');
					const buttonPrice = this.querySelector('[data-js-product-add-to-cart-text]');
					const button = this.querySelector('[data-js-product-add-to-cart]')
					const productPrice = this.querySelector('[data-js-quick-buy-product-price]');
					if(productPrice !== null) {

						new MutationObserver(()=>{
							if ( cardPrice ) {
								cardPrice.innerHTML = productPrice.innerHTML;
								if ( productPrice.querySelector('[data-js-product-price-original]').textContent != '' ) {
									cardPrice.parentNode.classList.remove('product-item__price--empty');
								} else {
									cardPrice.parentNode.classList.add('product-item__price--empty');
								}
							}
							
							if ( this.dataset.addToCartPrice == "true" && ! button.classList.contains('disabled') ) {
								buttonPrice.innerHTML = `${buttonPrice.innerHTML} <span class='element--hide-on-small'>- ${productPrice.innerHTML}</span>`;
							}
							
						}).observe(productPrice, {
							attributes: false, childList: true, subtree: true
						})
					}

				}

				if ( this.dataset.defaultToFirstVariant == 'true' ) {
					this.querySelector('product-variants').updatePrice();
				}

			}, 10);

		*/	

		}

		onVariantChangeHandler(e){

			const variant = e.target.currentVariant;
let allVariantButtons;
			// Absolute addition:
			if(e) {		
				let thisSelect = e.target.querySelector('.product-variant__container--select');
				let thisAddToCartButton = e.target.closest('.product-item__quick-buy').querySelector('form.form');
				if(e.target.closest('.product-item__quick-buy')) {
					allVariantButtons = e.target.closest('.product-item__quick-buy').querySelectorAll('.button--download-asset--variant-hidden');
				}
				 
				
				if(thisSelect) {
					let thisVariantAlreadyPurchased = thisSelect.options[thisSelect.selectedIndex].getAttribute('data-alreadypurchased');
					let thisDownloadButton = thisSelect.options[thisSelect.selectedIndex].getAttribute('data-download');


					/*
					if(allVariantButtons) {
						allVariantButtons.forEach(item=>{
							item.classList.add('quick-buy-variant-hidden');
						})
					}
					*/


					const thisCardsContainer = e.target.closest('.product-item');
			


					if(thisVariantAlreadyPurchased == 'true') {

						/*
						// hide price and 'also own' text
						if(thisCardsContainer) {
							thisCardsContainer.classList.add('product-item__already_owned');
						}
						



						
						if(thisAddToCartButton) {
							thisAddToCartButton.classList.add('quick-buy-variant-hidden');
						}

						*/

						/*
						// show correct download button
						if(thisDownloadButton) {
							if(document.getElementById(thisDownloadButton)) {
								document.getElementById(thisDownloadButton).classList.remove('quick-buy-variant-hidden');
							}
						}
						*/
					} else {
						/*
						// hide price and 'also own' text
						if(thisCardsContainer) {
							thisCardsContainer.classList.remove('product-item__already_owned');
						}
						// show add to cart button
						if(thisAddToCartButton) {
							thisAddToCartButton.classList.remove('quick-buy-variant-hidden');
						}
						*/

					}
				}
			}


			if ( variant ) {

				if ( this.variantImages ) {
				
					if ( variant.featured_media != null ) {
						const variantImg = this.variantImages.querySelector(`template[data-media-id="${variant.featured_media.id}"]`);
						if ( ! variantImg.dataset.init ) {
							this.initVariantImage(variantImg);
							this.showVariantImage(variant.featured_media.id);
						} else {
							this.showVariantImage(variant.featured_media.id);
						}
					}

				} else if ( this.variantImagesSliders ) {

					if ( variant.featured_image != null && this.productSlider ) {
						const variantImg = this.productSlider.querySelector(`.product-item__image-${variant.featured_image.id}`);
						this.productSlider.changeSlide(variantImg.dataset.index);
					}

				}

			}

		}

		initVariantImage(template) {
			template.dataset.init = true;
			const image = template.content.querySelector('figure').cloneNode(true);
			image.dataset.mediaId = template.dataset.mediaId;
			this.productImage.append(image);
		}

		showVariantImage(id) {
			this.productImage.querySelector('.product-item__image-figure--on-top')?.classList.remove('product-item__image-figure--on-top');
			this.productImage.querySelector(`[data-media-id="${id}"]`).classList.add('product-item__image-figure--on-top');
			this.productImage.querySelector(`[data-media-id="${id}"] img`).srcset = this.productImage.querySelector(`[data-media-id="${id}"] img`).srcset;
			this.productImage.querySelector(`[data-media-id="${id}"]`).style.zIndex = ++this.zIndex;
		}

		_serializeForm(form) {
			let arr = [];
			Array.prototype.slice.call(form.elements).forEach(function(field) {
				if (
					!field.name ||
					field.disabled ||
					['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
				)
					return;
				if (field.type === 'select-multiple') {
					Array.prototype.slice.call(field.options).forEach(function(option) {
						if (!option.selected) return;
						arr.push(
							encodeURIComponent(field.name) +
								'=' +
								encodeURIComponent(option.value)
						);
					});
					return;
				}
				if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
					return;
				arr.push(
					encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
				);
			});
			return arr.join('&');
		}

	}

  if ( typeof customElements.get('quick-buy') == 'undefined' ) {
		customElements.define('quick-buy', QuickBuy);
	}

}

if ( ! window.handleAddToCart ) {

	window.handleAddToCart = (body, items, headers, callback) => {

	// Absolute addition - if it's a subscription or topup product, go straight to checkout
	// extract product-id from body - see if it matches either the top up or product so we can go straight to checkout if so
	let shouldForceCheckout = false;
	// form_type=product&utf8=%E2%9C%93&id=41941890302022&product-id=7631462170694&quantity=1&product-id=7637670264902&section-id=template--16062076289094__absolute_subscribe_tiers_ammw43
	const thisProductId = parseInt(body.split("&product-id=")[1].split("&")[0],10);
	if((thisProductId == topup_product_id) || (thisProductId == subscription_product_id)) {
		shouldForceCheckout = true;
	}

	if(window.localStorage.getItem('savedCart') != null) {
		// add a value that can be picked up in the checkout:
		body += '&properties%5B_savedcart%5D=true';
	}

	// end Absolute addition

		let alert = '';

		fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
			body: body,
			headers: headers,
			method: 'POST'
		})
		.then(response => response.json())
		.then(response => {
			if ( response.status == 422 ) {
				// wrong stock logic alert
				alert = document.createElement('span');
				alert.className = 'alert alert--error';
				alert.innerHTML = response.description
				return fetch('?section_id=helper-cart');
			} else {
				return fetch('?section_id=helper-cart');
			}
		})
		.then(response => response.text())
		.then(text => {

			let doNext = false;

			if ( document.body.classList.contains('template-cart' ) ) {
				doNext = "page";
			} else {
				if ( KROWN.settings.cart_popup == "true" && document.getElementById('mini-cart-popup') ) {
					doNext = "popup";
				} else if ( KROWN.settings.cart_action == "overlay" && document.getElementById('site-cart-sidebar') ) {
					doNext = "drawer";
				} else {
					doNext = "page";
				}
			}

			// Absolute addition - if it's a subscription or topup product, go straight to checkout
			if (shouldForceCheckout) {
				/*if(document.getElementById('CheckOut')) {
					document.getElementById('CheckOut').click();
				} else {
					window.location.href = KROWN.settings.routes.cart_url;
				}
				*/
				// set a session storage value to confirm they did visit the checkout if there was a mixed cart saved:
				window.sessionStorage.setItem('checkout_visit','true'); 
				window.location.href = '/checkout/';
			} else {
			// end Absolute addition

				if ( doNext == "page" ) {
					window.location.href = KROWN.settings.routes.cart_url;
				} else {

					if ( document.getElementById('site-cart-sidebar') ) {

						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

						const cartItems = document.getElementById('AjaxCartForm');
						cartItems.innerHTML = cartFormInnerHTML;
						cartItems.ajaxifyCartItems();

						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.innerHTML = document.querySelector('#AjaxCartForm [data-cart-count]').innerHTML;
						});

						if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}

						if ( alert != '' ) {
							document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
						}
						document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
						
					}

					if ( doNext == "drawer" ) {
						document.getElementById('site-cart-sidebar').show();
					} else {
						const miniCartPopup = document.getElementById('mini-cart-popup')
						if ( items == 1 ) {
							miniCartPopup.querySelector('[data-js-mini-cart-single]').style.display = 'block';
							miniCartPopup.querySelector('[data-js-mini-cart-plural]').style.display = 'none';
						} else {
							miniCartPopup.querySelector('[data-js-mini-cart-plural]').style.display = 'block';
							miniCartPopup.querySelector('[data-js-mini-cart-plural]').innerHTML = KROWN.settings.locales.cart_added_items_count.replace('{{ count }}', items);
							miniCartPopup.querySelector('[data-js-mini-cart-single]').style.display = 'none';
						}
						const miniCartPopupInner = miniCartPopup.querySelector('.mini-cart-popup');
						if ( miniCartPopupInner ) {
							miniCartPopupInner.classList.remove('mini-cart-popup--collapsed');
						}
						miniCartPopup.show();
						// guests have no cart icon in the header (see sections/header.liquid).
						// Logged-in visitors still auto-hide on the merchant-configured timer;
						// guests instead collapse to just the "View Cart" button after 5s,
						// since that stays as their only way back to the cart.
						if ( KROWN.settings.customer_logged_in == 'true' ) {
							if ( miniCartPopup.dataset.hide != '0' ) {
								setTimeout(()=>{
									miniCartPopup.hide();
								}, parseInt(miniCartPopup.dataset.hide));
							}
						} else {
							setTimeout(()=>{
								if ( miniCartPopupInner ) {
									miniCartPopupInner.classList.add('mini-cart-popup--collapsed');
								}
							}, 5000);
						}
					}
					
				}

				// Absolute addition - reload Collection listing to add logic for blocking/allowing products:
				if(typeof FacetFiltersForm !== "undefined") {
					FacetFiltersForm.renderPage(FacetFiltersForm.searchParamsPrev, null, false, true);
				}
				// search page needs reloading:
				if(document.body.classList.contains('template-search')) {
					window.location.reload();
				}
				// Absolute addition - show cart icon (it's hidden if not logged in)
				document.querySelectorAll('#site-header .area--cart').forEach((carticon) => {
				  carticon.classList.remove('visually-hidden');
				});
			}

		})
		.catch(e => {
			console.log(e);
		})
		.finally(() => {
			callback();
		});

	}

}